import { createUploadLink } from "apollo-upload-client";
import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter as Router } from "react-router-dom";

import {
  ApolloClient,
  ApolloLink,
  ApolloProvider,
  InMemoryCache,
} from "@apollo/client";

import App from "./App";
import reportWebVitals from "./reportWebVitals";

const httpLink = createUploadLink({
  uri: "/graphql",
  credentials: "include",
}) as unknown as ApolloLink;

const client = new ApolloClient({
  link: httpLink,
  cache: new InMemoryCache(),
});

const isDev = process.env.NODE_ENV !== "production";

ReactDOM.render(
  <React.Fragment>
    {isDev && <React.StrictMode />}
    <Router>
      <ApolloProvider client={client}>
        <App />
      </ApolloProvider>
    </Router>
  </React.Fragment>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
